import { render, staticRenderFns } from "./BorderSettings.vue?vue&type=template&id=172772d2"
import script from "./BorderSettings.vue?vue&type=script&lang=js"
export * from "./BorderSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports